/**
 * sophior-cart-sync.js
 * Centrale cart-flow rond add-to-cart en de cart-knop. Eén open-mechanisme:
 * 1. Native SOPHIOR cart drawer (cart_type 'drawer', snippets/cart-drawer.liquid)
 * 2. Fallback: /cart (drawer niet gerenderd, bv. cart_type 'page')
 *
 * Events:
 * - 'sophior:cart-updated' → headerteller verversen via /cart.js
 * - 'sophior:open-cart'    → drawer openen (of /cart)
 * Daarnaast luistert de teller op Dawn's pubsub 'cartUpdate', zodat hij ook
 * synchroon blijft bij aantal-wijzigingen/verwijderingen ín de native drawer.
 */
(function () {
  function updateBadge() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var btn = document.getElementById('sophior-cart-btn');
        if (!btn) return;
        var badge = btn.querySelector('.sophior-header__cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'sophior-header__cart-count';
            btn.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      })
      .catch(function () { /* teller-update is best effort */ });
  }

  /* Native drawer: eerst de inhoud verversen via de Section Rendering API en
     dan pas openen. De quick-add- en keuzehulp-flows posten naar /cart/add.js
     zonder sections-parameter; zonder refresh zou de drawer de
     server-gerenderde (verouderde) inhoud tonen. De addon-bundel en de
     drawer-upsell sturen wél sections mee en renderen atomisch. */
  function vernieuwDrawer(drawer) {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '?sections=cart-drawer')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        var html = sections && sections['cart-drawer'];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var freshInner = fresh.querySelector('#CartDrawer');
        var target = drawer.querySelector('#CartDrawer');
        var freshRoot = fresh.querySelector('cart-drawer');
        if (freshInner && target) {
          target.innerHTML = freshInner.innerHTML;
          /* innerHTML-replace verwijdert de overlay-listener uit de constructor */
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        if (freshRoot) drawer.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
      });
  }

  function openNativeDrawer(drawer) {
    vernieuwDrawer(drawer)
      .catch(function () { /* verouderde inhoud tonen is beter dan niets */ })
      .then(function () {
        if (typeof drawer.open === 'function') drawer.open();
      });
  }

  /* ---- F0-b: focus terug naar de knop die de drawer opende ----------------
     Redesign Het Werkblad, golf 1 (D05 §0a en §3.1.9, P7 #10; eigenaar
     s07-drawer). Draait alleen als <cart-drawer> het attribuut
     data-sophior-drawer-fix draagt: de poort in snippets/cart-drawer.liquid zet
     het bij de schakelaar sophior_uitrol_drawer_fix. Zonder attribuut is
     focusTerug null en blijft alles zoals het was (na sluiten stond de focus
     dan vaak op body, omdat de header-knop en de open-cart-flows de drawer
     openen zonder Dawn te vertellen wie hem opende).
     Werking:
     - Een click-listener in de capture-fase onthoudt de laatst geactiveerde
       knop of link buiten de drawer (op iOS Safari focust een tik een knop
       niet, dus document.activeElement is daar vaak body).
     - Bij sophior:open-cart: trigger = detail.trigger, anders die laatste
       activering, anders document.activeElement, anders de tasknop in de
       header (#sophior-cart-btn); via drawer.setActiveElement() vóór open().
     - Bij de overgang naar open (ook het renderContents()-pad van de PDP, de
       add-onbundel, quick-add en de bestelstrook): een ontbrekend of onbruikbaar
       actief element (body, binnen de drawer, niet meer in de pagina) wordt op
       dezelfde manier vervangen.
     - Na sluiten heeft Dawn's close() de focus al naar dat element gezet. Lukte
       dat niet (element verborgen of weg), dan gaat de focus naar de tasknop,
       zonder te scrollen. Daarna worden trigger en activering gewist, zodat de
       volgende opening nooit een oude trigger erft.
     Het K-01-contract (Section Rendering, id's, inline .drawer-CSS) blijft
     ongemoeid: dit raakt alleen activeElement en de focus. */
  var focusTerug = (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.hasAttribute('data-sophior-drawer-fix')) return null;

    /* Een quick-add of keuzehulp stuurt open-cart pas na het antwoord van
       /cart/add.js; op een trage mobiele verbinding duurt dat langer dan 2 s.
       De activering wordt bij elke sluiting gewist, dus 15 s is geen risico. */
    var MAX_LEEFTIJD = 15000;
    var laatste = null;
    var isOpen = drawer.classList.contains('active');

    function inDrawer(el) {
      return !!(el && el.closest && el.closest('cart-drawer'));
    }
    function bruikbaar(el) {
      return !!(el && el.nodeType === 1 && el !== document.body && el !== document.documentElement &&
        document.documentElement.contains(el) && !inDrawer(el) && typeof el.focus === 'function');
    }
    function tasknop() {
      return document.getElementById('sophior-cart-btn') || document.querySelector('[data-cart-toggle]');
    }
    function kies(voorkeur) {
      if (bruikbaar(voorkeur)) return voorkeur;
      if (laatste && Date.now() - laatste.t <= MAX_LEEFTIJD && bruikbaar(laatste.el)) return laatste.el;
      if (bruikbaar(document.activeElement)) return document.activeElement;
      var knop = tasknop();
      return bruikbaar(knop) ? knop : null;
    }
    function zet(el) {
      if (!el) return;
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(el);
      else drawer.activeElement = el;
    }
    function focusLosgeraakt() {
      var a = document.activeElement;
      return !a || a === document.body || a === document.documentElement || inDrawer(a);
    }

    document.addEventListener('click', function (evt) {
      var el = evt.target && evt.target.closest
        ? evt.target.closest('button, a[href], summary, [role="button"], input[type="submit"], input[type="button"]')
        : null;
      if (el && !inDrawer(el)) laatste = { el: el, t: Date.now() };
    }, true);

    /* Alleen de overgang dicht -> open en open -> dicht telt; is-empty en
       animate wisselen ook de klasse, maar veranderen de stand niet. */
    new MutationObserver(function () {
      var nu = drawer.classList.contains('active');
      if (nu === isOpen) return;
      isOpen = nu;
      if (nu) {
        zet(kies(drawer.activeElement));
        return;
      }
      if (focusLosgeraakt()) {
        var knop = tasknop();
        if (knop && !inDrawer(knop)) knop.focus({ preventScroll: true });
      }
      drawer.activeElement = null;
      laatste = null;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    return {
      bijOpenen: function (detail) {
        if (isOpen && bruikbaar(drawer.activeElement)) return;
        zet(kies(detail && detail.trigger));
      }
    };
  })();

  /* Snelle betaalknoppen onder AFREKENEN (sophior_uitrol_snelbetalen, 09 §4, RB-07;
     D05 §3.1.8, RD05-13). Alleen als <cart-drawer> data-sophior-snelbetalen-aan draagt
     (de poort in snippets/cart-drawer.liquid en sophior-pakbon-drawer.liquid zet dat
     attribuut), in de huidige drawer en in drawer v2. Shopify rendert de wallets opnieuw
     als de sectie via de Section Rendering API terugkomt (shopify.dev, Accelerated
     checkout); na elke swap roepen we daarnaast Shopify.PaymentButton.init() aan als die
     bestaat, één keer per nieuwe container. */
  (function () {
    var drawer = document.querySelector('cart-drawer[data-sophior-snelbetalen-aan]');
    if (!drawer || !window.MutationObserver) return;
    var gepland = false;
    function init() {
      gepland = false;
      var c = drawer.querySelector('[data-sophior-snelbetalen]');
      if (!c || c.hasAttribute('data-sophior-snelbetalen-klaar')) return;
      c.setAttribute('data-sophior-snelbetalen-klaar', '');
      var pb = window.Shopify && window.Shopify.PaymentButton;
      if (pb && typeof pb.init === 'function') {
        try { pb.init(); } catch (e) { /* de wallets renderen ook zonder */ }
      }
    }
    new MutationObserver(function () {
      if (!gepland) {
        gepland = true;
        requestAnimationFrame(init);
      }
    }).observe(drawer, { childList: true, subtree: true });
    init();
  })();

  /* Voor assets/sophior-pakbon.js (drawer v2 en /cart v2, B4; laadt alleen met
     sophior_uitrol_b4_drawer en master b4 aan, na dit bestand): dezelfde verversing
     en teller, zodat er één drawer-fetch blijft. */
  window.SophiorCartSync = { vernieuwDrawer: vernieuwDrawer, updateBadge: updateBadge };

  function openCart(evt) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (focusTerug) focusTerug.bijOpenen(evt && evt.detail);
      openNativeDrawer(drawer);
    } else {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  document.addEventListener('sophior:cart-updated', updateBadge);
  document.addEventListener('sophior:open-cart', openCart);

  /* Upsell-knop in de native drawer (snippets/sophior-cart-drawer-upsell.liquid).
     Event-delegation op document: de drawer-inhoud wordt bij elke cart-update
     via innerHTML vervangen, directe listeners overleven dat niet. */
  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('[data-sophior-drawer-add]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    btn.disabled = true;
    /* Drawer v2 (B4): de rijen zijn kitknoppen (de omlijnde "+") met de laadstaat
       via aria-busy (sophior-ui.css); bron uit data-source (drawer-upsell,
       herbestel-drawer of drempelbrug; D01 §5.9). De huidige drawer heeft geen
       data-source en geen kitknop: daar blijft alles zoals het was. */
    var kitKnop = btn.classList.contains('sophior-btn');
    var bron = btn.dataset.source || 'drawer-upsell';
    if (kitKnop) btn.setAttribute('aria-busy', 'true');
    var pakbon = window.SophiorPakbon || null;
    if (pakbon) pakbon.verwachtToevoeging();

    /* Sections meesturen en het antwoord atomisch renderen (zelfde patroon
       als de PDP-addon-bundel): een nieuw item komt vooraan in cart.items en
       schuift alle regelnummers op, terwijl de oude data-index-waarden nog in
       de open drawer staan. Met een losse refresh-fetch achteraf kan een
       +/−-klik in dat venster de verkeerde regel raken. */
    var drawer = document.querySelector('cart-drawer');
    var payload = {
      id: parseInt(btn.dataset.variantId, 10),
      quantity: 1,
      properties: { _sophior_source: bron }
    };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('sophior:cart-updated'));
        if (drawer && data && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        } else {
          /* Fallback zonder sections-antwoord: drawer verversen via openCart */
          document.dispatchEvent(new CustomEvent('sophior:open-cart'));
        }
        /* Op /cart ligt onder de drawer óók de paginalijst (cart-items) met
           regelnummer-gebaseerde +/−-knoppen; die ververst niet mee met de
           drawer. Zonder deze publish blijven daar oude data-index-waarden
           staan en raakt een latere klik de verkeerde regel. */
        if (document.getElementById('main-cart-items') &&
            typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sophior-drawer-upsell', cartData: data });
        }
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('sophior_addon_added_to_cart', {
            source: bron,
            variantIds: [btn.dataset.variantId]
          });
        }
      })
      .catch(function () {
        btn.disabled = false;
        if (kitKnop) btn.removeAttribute('aria-busy');
        if (pakbon) pakbon.geenToevoeging();
        /* Niet stil falen: toon een korte melding in de upsell-kaart
           (bijv. add-on net uitverkocht of netwerkfout). De melding verdwijnt
           vanzelf bij de eerstvolgende cart-update (drawer her-rendert).
           Drawer v2: de rij is kaart v2 (.sophior-kaart) of de pakbonrij. */
        var card = btn.closest('.sophior-drawer-upsell__card, .sophior-kaart, .pakbon-rij');
        var body = card ? card.querySelector('.sophior-drawer-upsell__body, .sophior-kaart__tekst, .pakbon-rij__tekst') : null;
        if (body) {
          var note = body.querySelector('.sophior-drawer-upsell__error');
          if (!note) {
            note = document.createElement('p');
            note.className = 'sophior-drawer-upsell__error';
            note.setAttribute('role', 'alert');
            body.appendChild(note);
          }
          note.textContent = btn.dataset.errorText || 'Toevoegen is niet gelukt, probeer het opnieuw.';
        }
      });
  });

  /* Dawn-native paden (PDP-form, quantity/remove in de drawer) publiceren
     'cartUpdate' via pubsub.js maar dispatchen geen sophior:cart-updated.
     NB: PUB_SUB_EVENTS is een top-level const (geen window-property), dus
     alleen via typeof te detecteren. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateBadge);
  }
})();
